module.exports = __webpack_public_path__ + "07_long_black.97e281d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/07_long_black.png
// module id = 8BQP
// module chunks = 0